/** کش sessionStorage وابسته به شرکت — جلوگیری از نمایش داده شرکت قبلی پس از تعویض پنل */

export const CRM_ACTIVE_COMPANY_KEY = 'crm_active_company_id';

export const readCachedAuthCompanyId = () => {
  try {
    const raw = localStorage.getItem('userData');
    if (!raw) return null;
    const data = JSON.parse(raw);
    const id = data?.company_id;
    return id != null ? id : null;
  } catch {
    return null;
  }
};

export const dealsFilterStorageKey = (companyId = readCachedAuthCompanyId()) =>
  companyId != null ? `crm_deals_filter_options_${companyId}` : 'crm_deals_filter_options';

const CRM_SESSION_PREFIXES = [
  'crm_deals_filter_options',
  CRM_ACTIVE_COMPANY_KEY,
  'crm_follow_up_reminder_shown_ids',
];

export const clearCompanySessionCache = () => {
  try {
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (!key) continue;
      if (CRM_SESSION_PREFIXES.some((prefix) => key === prefix || key.startsWith(`${prefix}_`))) {
        keys.push(key);
      }
    }
    // کلید قدیمی بدون company_id
    keys.push('crm_deals_filter_options');
    [...new Set(keys)].forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // ignore
  }
};

/** هنگام ورود/تعویض workspace — اگر شرکت عوض شده کش قبلی پاک شود */
export const syncCompanySessionCache = (companyId) => {
  try {
    const next = companyId != null ? String(companyId) : '';
    const prev = sessionStorage.getItem(CRM_ACTIVE_COMPANY_KEY);
    if (prev && prev !== next) {
      clearCompanySessionCache();
    }
    if (next) {
      sessionStorage.setItem(CRM_ACTIVE_COMPANY_KEY, next);
    } else {
      sessionStorage.removeItem(CRM_ACTIVE_COMPANY_KEY);
    }
  } catch {
    // ignore
  }
};
